












































































import { CREATE_PAYMENT_INTENT } from "@/queries/customer/mutation.graphql";
import { stripe } from "@/services/stripe/stripe";
import { bus } from "@/utils/event-emitter";
import Vue from "vue";
export default Vue.extend({
  props: {
    show: {
      type: Boolean,
    },
  },
  data() {
    return {
      cardNumber: null,
      cardCvc: null,
      cardExpiry: null,
      isSubmiting: false,
      errorMsg: "",
    };
  },
  methods: {
    async onAddCard() {
      this.isSubmiting = true;
      const { token, error } = await stripe.createToken(this.cardNumber);
      console.log(error, token);
      if (error) {
        this.isSubmiting = false;
        return;
      }
      const {
        data: { generateStripePaymentIntent },
        errors,
      } = await this.$apollo.mutate({
        mutation: CREATE_PAYMENT_INTENT,
      });
      const {
        paymentIntent,
        error: paymentError,
      } = await stripe.confirmCardPayment(
        generateStripePaymentIntent.clientSecret,
        {
          payment_method: {
            card: this.cardNumber,
          },
        }
      );
      this.isSubmiting = false;
      if (paymentError) {
        this.errorMsg = paymentError.message;
        return;
      }
      if (paymentIntent) {
        bus.$emit("creditCardSuccess");
      }
    },
    displayError({ error }) {
      if (error) {
        this.errorMsg = error.message;
      } else {
        this.errorMsg = "";
      }
    },
  },
  created() {
    console.log(stripe);
  },
  watch: {
    show() {
      if (this.show) {
        this.$nextTick(() => {
          const cardNumberElm = this.$refs.cardNumber as HTMLElement;
          const cardCvcElm = this.$refs.cardCvc as HTMLElement;
          const cardExpiryElm = this.$refs.cardExpiry as HTMLElement;

          const elements = stripe.elements();
          this.cardNumber = elements.create("cardNumber", {
            placeholder: "Card Number",
            classes: {
              base: "py-15 px-20",
            },
          });
          this.cardCvc = elements.create("cardCvc", {
            classes: {
              base: "py-15 px-20",
            },
          });
          this.cardExpiry = elements.create("cardExpiry", {
            classes: {
              base: "py-15 px-20",
            },
          });
          this.cardNumber.mount(cardNumberElm);
          this.cardExpiry.mount(cardExpiryElm);
          this.cardCvc.mount(cardCvcElm);
          this.cardNumber.on("change", this.displayError);
          this.cardCvc.on("change", this.displayError);
          this.cardExpiry.on("change", this.displayError);
        });
      }
    },
  },
});
